import React from 'react';
import { ThemeProvider } from 'styled-components';

import { ResponseVariant, responseVariantTheme } from './responseScale';

/**
 * Picks the scale every response block below it draws at. It rides the styled-components theme,
 * so a nested part (a button, a field, a result card) reads it without a prop.
 */
const ResponseScaleProvider: React.FC<{ variant: ResponseVariant; children: React.ReactNode }> = ({
  variant,
  children
}) => <ThemeProvider theme={responseVariantTheme[variant]}>{children}</ThemeProvider>;

export default ResponseScaleProvider;
